import React from "react";
import { useTheme } from "@mui/styles";
import { Box, Typography, Divider, useMediaQuery } from "@mui/material";
import CodingChallengeTopics from "./CodingChallengeTopics";
import CodingChallengeRemote from "./CodingChallengeRemote";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    background:
      "linear-gradient(180deg, rgba(4,17,43,1) 0%, rgba(6,23,53,1) 100%)",
    width: { xs: "100%" },
    borderRadius: { xs: "8rem 0 8rem 0" },
    margin: "4rem 0 14rem 0",
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  titleContainer: {
    mt: { xs: "147px", md: "100px", xl: "135px" },
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
  title: {
    color: theme.palette.red.main,
    fontSize: { xs: "14px", md: "16px" },
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontFamily: theme.typography.montserrat.semibold,
  },
  span: {
    fontWeight: "bold",
  },
  subtitle: {
    mt: { xs: "11px", md: "27px", lg: "35px", xl: "42px" },
    maxWidth: { xs: "225px", md: "510px", lg: "663px", xl: "882px" },
    height: { xs: "auto", md: "74px", lg: "76px", xl: "79px" },
    fontFamily: theme.typography.montserrat.light,
    fontSize: { xs: "32px", md: "43px", lg: "54px", xl: "65px" },
    textAlign: { xs: "center" },
    lineHeight: { xs: "36px" },
    color: theme.palette.white.main,
    fontWeight: { md: "bold" },
  },
  text: {
    mt: { xs: "41px", md: 0, lg: 0, xl: "39px" },
    maxWidth: { xs: "265px", md: "800px", lg: "900px", xl: "1198px" },
    height: { xs: "auto", md: "auto", lg: "auto", xl: "115px" },
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "18px", md: "16px", lg: "18px", xl: "24px" },
    textAlign: { xs: "center" },
    lineHeight: { xs: "32px", lg: "36px", xl: "42px" },
    color: theme.palette.white.main,
  },
  divider: {
    border: `.5px solid ${theme.palette.white.main}`,
    mt: { xs: "59.5px", md: "65px", lg: "75px", xl: "84.5px" },
    width: { xs: "100%" },
    maxWidth: { xs: "282px", md: "600px", lg: "900px", xl: "1383px" },
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
});

const CourseModality = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:899px)");
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const { title, subtitle, description } = useTranslation(
    pathname,
    "CourseModality"
  );

  return (
    <Box sx={classes.container}>
      <Box sx={classes.titleContainer}>
        {isMobile ? null : <div style={classes.line}></div>}
        <Typography sx={classes.title}>{title}</Typography>
      </Box>
      <Typography sx={classes.subtitle}>{subtitle}</Typography>
      <Typography sx={classes.text}>{description}</Typography>
      {isMobile && <Divider sx={classes.divider} />}
      <CodingChallengeRemote />
      <Divider sx={classes.divider} />
      <CodingChallengeTopics />
    </Box>
  );
};

export default CourseModality;
